import React, { FC, useMemo } from 'react';

import { EvIssueTypesBySeverityBreakdownChart, PatternData } from '@evinced-private/ui-common';

import {
	mobileSeverityPatterns,
	prepareDataForTotalIssuesBreakdownByIssueTypeChart
} from 'src/common/helpers/MobileChartsHelper';
import { MobileIssueTypeCount } from 'src/common/types/MobileSingleSessionTypes';

interface IMobileTotalIssuesBreakdownByIssueTypeChartProps {
	data: MobileIssueTypeCount[];
	onBarClick: (issueType: string, scanName: string) => void;
}

export const MobileTotalIssuesBreakdownByIssueTypeChart: FC<
	IMobileTotalIssuesBreakdownByIssueTypeChartProps
> = ({ data, onBarClick }) => {
	const transformedData = useMemo(
		() => prepareDataForTotalIssuesBreakdownByIssueTypeChart(data),
		[data]
	);

	const patterns: PatternData[] = useMemo(() => {
		const allIssueTypes = transformedData.flatMap((severity) => severity.issueTypesCount);

		return allIssueTypes.map((issueType) => {
			const severityPattern = mobileSeverityPatterns.find(
				(pattern) => pattern.id === issueType.severityId
			);

			return {
				id: issueType.id,
				label: issueType.typeLabel,
				color: severityPattern?.color || ''
			};
		});
	}, [transformedData]);

	return (
		<EvIssueTypesBySeverityBreakdownChart
			enableFocusBorder={true}
			typesCountBySeverity={transformedData}
			patterns={patterns}
			onBarItemClick={({ type }) => {
				const originalItem = data.find((item) => item.type === type);
				const scanName = originalItem?.scanName || '';
				onBarClick(type, scanName);
			}}
		/>
	);
};
